import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const Pagination = ({ page, totalPages, onPageChange, className = '' }) => {
  if (!totalPages || totalPages <= 1) return null;

  return (
    <div
      className={`flex items-center justify-between px-4 py-3 border-t border-gray-200 bg-gray-50 ${className}`}
    >
      <button
        onClick={() => onPageChange(page - 1)}
        disabled={page <= 1}
        className="flex items-center gap-1 px-3 py-1.5 text-sm font-medium text-gray-600 hover:text-primary-600 disabled:text-gray-300 disabled:cursor-not-allowed transition-colors"
      >
        <ChevronLeft className="w-4 h-4" />
        Əvvəlki
      </button>

      <span className="text-sm text-gray-600">
        Səhifə <span className="font-semibold text-gray-900">{page}</span> /{' '}
        {totalPages}
      </span>

      <button
        onClick={() => onPageChange(page + 1)}
        disabled={page >= totalPages}
        className="flex items-center gap-1 px-3 py-1.5 text-sm font-medium text-gray-600 hover:text-primary-600 disabled:text-gray-300 disabled:cursor-not-allowed transition-colors"
      >
        Sonrakı
        <ChevronRight className="w-4 h-4" />
      </button>
    </div>
  );
};

export default Pagination;
